import React, { Component } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import _ from 'lodash';
import { connect } from 'react-redux';
import StretchImage from '../Components/General/StretchImage';
import DonorFullPage from '../Components/Donor/DonorFullPage';
import shared from '../utils/shared';
import BRSpan from '../Components/General/BRSpan';
const config = {
    cycleImageTime: 120000, //will cycle in sync with closest slide cycle
    topBarHeight: 0.08, //as percentage of screen height
}

class DisplayContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            renderSides: true,
            renderFull: false,
            renderWhite: true,
            cycleIndex: 0,
            donorData: { left: null, right: null },
            backgroundIndex: 0,
            eventIndex: -1,
            topBarHeader: "Donors",
            showTopBar: true,
            list: null,
            f: null
        }

        this.columns = 2
        this.rows = 16

        this.backgroundImages = [];
        this.slideImages = [];
        this._events = [];
        this._backgroundEvents = [];
        this._includeCategories = [];
        this._donorLists = [];
        this._parentIndex = -1;
        this._parentCategory = {};

        //CUSTOM VARS
        this._fullScreenSlides = false;
        this._panelOpacity = 0.5;
        //this._footer = "* Denotes Deceased **While every effort is made to ensure the accuracy of the information displayed, should you discover an error, please notify the Baylor Scott & White-Central Texas Foundation at 1-800-293-4483.";
        this._slideTop = this.props.screen.sv.height * config.topBarHeight;;
        this._slideHeight = this.props.screen.sv.height - (this.props.screen.sv.height * config.topBarHeight)
        this._fadeClass = "slowfade";
        if (this.props.content.settings.custom_vars) {
            if (shared.flexibleBool(this.props.content.settings.custom_vars.FullScreenSlides) === true) {
                this._fullScreenSlides = true;
                this._slideTop = 0
                this._slideHeight = this.props.screen.sv.height;
            }
            if (this.props.content.settings.custom_vars.BackgroundOpacity) {
                this._panelOpacity = Number(this.props.content.settings.custom_vars.BackgroundOpacity);
            }
            // if (this.props.content.settings.custom_vars.Footer) {
            //     this._footer = this.props.content.settings.custom_vars.Footer;
            // }
            if (this.props.content.settings.custom_vars.DelayFade){
                this._fadeClass="slowfadedelay"
            }
        }

        if (this.props.content.dm_active) {

            _.forEach(this.props.content.dm_active, (dm, index) => {
                if (dm.display_module_type === "Donor List") {
                    this._donorLists.push(dm);
                }
            });
            if (this._donorLists.length === 0) {
                console.log("Configuration Error: No donor lists detected please add a donor list module to the display.")
            }
            let backgroundModule = _.find(this.props.content.dm_active, { display_module_type: "Slideshow", name: "Background" });
            if (!backgroundModule) {
                console.log("Configuration Error: No background module detected, please add a Slideshow module with name Background.");
            }
            _.forEach(backgroundModule.contents.images, (image, index) => {
                let cycletime = 120000;
                if (_.has(backgroundModule, 'contents.cycle_overrides[' + index + ']')) {
                    cycletime = backgroundModule.contents.cycle_overrides[index] * 1000;
                }
                this.backgroundImages.push(shared.dpath(this.props.screen.mode, image.path, image.file_name, this.props.screen.webkey));
                this._backgroundEvents.push({ cycletime: cycletime, image: shared.dpath(this.props.screen.mode, image.path, image.file_name, this.props.screen.webkey) })
            });

            let slideModule = _.find(this.props.content.dm_active, { display_module_type: "Slideshow", name: "Slides" });

            _.forEach(this._donorLists, list => {
                let donorListCycleTime;
                if (_.has(list, 'contents.cycle_time')) {
                    donorListCycleTime = list.contents.cycle_time
                }
                else {
                    donorListCycleTime = 5;
                }
                this._events.push({ name: "Donor List", title: "Donors", delay: donorListCycleTime * 1000, image: null });
                this.initList(list);
                //save all style attributes here?


            })

            _.forEach(slideModule.contents.images, (image, index) => {
                let cycle_time = 25000
                let name = "Background";
                let title = "";
                let img = null;
                //cycle times
                if (_.has(slideModule, 'contents.cycle_overrides[' + index + ']')) {
                    cycle_time = slideModule.contents.cycle_overrides[index]
                }
                else {
                    console.log("Slide detected with no cycle time using default", cycle_time);
                }
                //empty background and slides
                let isEmpty = false;
                if (_.has(slideModule, 'contents.empty_slides[' + index + ']')) {
                    isEmpty = slideModule.contents.empty_slides[index]
                    if (isEmpty === false) {
                        name = "Slide";
                    }
                }
                else {
                    console.log("No variable for empty time, check configuration", isEmpty);
                }

                if (_.has(slideModule, 'contents.names[' + index + ']')) {
                    title = slideModule.contents.names[index];
                }

                if (_.has(slideModule, 'contents.images[' + index + ']')) {
                    img = slideModule.contents.images[index]
                }
                this._events.push({ name: name, title: title, delay: cycle_time * 1000, image: shared.dpath(this.props.screen.mode, img.path, img.file_name, this.props.screen.webkey) });

                this.slideImages.push(shared.dpath(this.props.screen.mode, image.path, image.file_name, this.props.screen.webkey));
            });

        }
        //Background image handling
        if (this.backgroundImages.length === 0) { //fallback
            this.backgroundImages = [
                '/img/ui/sample_1.jpg',
                '/img/ui/sample_2.jpg'
            ]
        }

        this._cycleImageNow = false;
        this._cycleImageTimeout = null;
        this._donors = null;
        this._categoryCurrent = 0;
        this._donorIndex = 0;
        this._loopTimeout = null;
        this._backgroundIndex = 0;
    }

    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyDown);
        this.cycleEvent();
        this.setLoopTimeout();
        this.cycleBackgroundTimeout();

    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);
        this.clearCycleImageTimeout();
        this.clearSetLoopTimeout();
    }

    clearCycleImageTimeout = () => {
        clearTimeout(this._cycleImageTimeout)
        this._cycleImageTimeout = null;
    }

    clearSetLoopTimeout = () => {
        clearTimeout(this._loopTimeout)
        this._loopTimeout = null;
    }

    cycleBackgroundTimeout = () => {
        this.clearCycleImageTimeout();
        this._cycleImageTimeout = setTimeout(() => {
            if (this._cycleImageNow === false) { //prevents double cycling
                this._cycleImageNow = true;
                this._backgroundIndex++;
                if (this._backgroundIndex > this._backgroundEvents.length - 1) {
                    this._backgroundIndex = 0
                }
            }
            this.cycleBackgroundTimeout();
        }, this._backgroundEvents[this._backgroundIndex].cycletime);
    }

    setLoopTimeout = (ms) => {
        this._loopTimeout = setTimeout(() => {
            this.loopContent();
            this.setLoopTimeout(this._events[this.state.eventIndex].delay)
        }, ms)
    }



    initList = (list) => {

        let includeCategories = [];
        let donor_view_category = list.contents.donor_view_category;
        let category = _.find(this.props.donors.donorCategories, { id: Number(donor_view_category) });
        for (var a = 0; a < list.contents.include_categories.length; a++) {
            if (Number(list.contents.include_categories[a]) !== Number(list.contents.donor_view_category)) {
                includeCategories.push(list.contents.include_categories[a])
            }
        }

        let preparedCategories = [];
        for (var b = 0; b < includeCategories.length; b++) {
            let category = _.find(this.props.donors.donorCategories, { id: includeCategories[b] });
            preparedCategories.push(category);
        }
        let donors = _.orderBy(preparedCategories, 'rank', 'asc');


        //FONT STYLES
        let _parentNameStyle = {};
        // let _parentSubheaderStyle = {};
        let _parentDescriptionStyle = {};
        let _subcategoryNameStyle = {};
        let _subcategorySubheaderStyle = {};
        let _subcategoryDescriptionStyle = {};
        let _nameListStyle = {};
        let _footerStyle = {};

        let _parentNameOffset = {};
        let _parentSubheaderOffset = {};
        let _parentDescriptionOffset = {};
        let _subcategoryNameOffset = {};
        let _subcategorySubheaderOffset = {};
        let _subcategoryDescriptionOffset = {};
        let _nameListOffset = {};
        let _footerOffset = {};

        let parentNameStyle = list.contents.ni_options.format.parent_category_name;
        if (list.contents.ni_options.backdropOpacity!==undefined){
            this._panelOpacity = list.contents.ni_options.backdropOpacity*.01;
            console.log("SET PANEL OPACITY");
        }
        else{
            console.log("NI OPTIONS", list.contents.ni_options);
            console.log("BACKDROP OPACITY", list.contents.ni_options.backdropOpacity);
        }
        //let parentSubheaderStyle = list.contents.ni_options.format.parent_category_subheader;
        let parentDescriptionStyle = list.contents.ni_options.format.parent_category_description;

        let subcategoryNameStyle = list.contents.ni_options.format.sub_category_name;
        let subcategorySubheaderStyle = list.contents.ni_options.format.sub_category_subheader;
        // let subcategoryDescriptionStyle = list.contents.ni_options.format.sub_category_description;

        let nameListStyle = list.contents.ni_options.format.name_list;
        let footerStyle = list.contents.ni_options.format.footer_text;


        this.setFontAttributes(_parentNameStyle, parentNameStyle);
        //this.setFontAttributes(_parentSubheaderStyle, parentSubheaderStyle);
        this.setFontAttributes(_parentDescriptionStyle, parentDescriptionStyle);

        this.setFontAttributes(_subcategoryNameStyle, subcategoryNameStyle);
        this.setFontAttributes(_subcategorySubheaderStyle, subcategorySubheaderStyle);
        // this.setFontAttributes(this._subcategoryDescriptionStyle, subcategoryDescriptionStyle);

        this.setFontAttributes(_nameListStyle, nameListStyle);
        this.setFontAttributes(_footerStyle, footerStyle);


        this._sumH = list.contents.ni_options.topMargin * .01 * this.props.screen.screenHeight; //adjust for base offset

        this.setOffset(_parentNameOffset, parentNameStyle);
        //this.setOffset(_parentSubheaderOffset, parentSubheaderStyle);
        this.setOffset(_parentDescriptionOffset, parentDescriptionStyle);
        this.setOffset(_subcategoryNameOffset, subcategoryNameStyle);
        this.setOffset(_subcategorySubheaderOffset, subcategorySubheaderStyle);
        // this.setOffset(_subcategoryDescriptionOffset, subcategoryDescriptionStyle);
        this.setOffset(_nameListOffset, nameListStyle);

        _footerOffset = {
            val: this.props.screen.screenHeight - footerStyle.height * .01 * this.props.screen.screenHeight
        }

        list.category = category;
        list.donors = donors;

        list.f = {
            parentName: {
                style: _parentNameStyle,
                meta: { visible: parentNameStyle.visible, offset: _parentNameOffset.val, height: parentNameStyle.height }
            },
            parentDescription: {
                style: _parentDescriptionStyle,
                meta: { visible: parentDescriptionStyle.visible, offset: _parentDescriptionOffset.val, height: parentDescriptionStyle.height }
            },
            subcategoryName: {
                style: _subcategoryNameStyle,
                meta: { visible: subcategoryNameStyle.visible, offset: _subcategoryNameOffset.val, height: subcategoryNameStyle.height }
            },
            subcategorySubheader: {
                style: _subcategorySubheaderStyle,
                meta: { visible: subcategorySubheaderStyle.visible, offset: _subcategorySubheaderOffset.val, height: subcategorySubheaderStyle.height }
            },
            nameList: {
                style: _nameListStyle,
                meta: { visible: nameListStyle.visible, offset: _nameListOffset.val, height: nameListStyle.height }
            },
            footer: {
                style: _footerStyle,
                meta: { visible: footerStyle.visible, offset: _footerOffset.val, height: footerStyle.height }
            }
        }
    }

    // initParentCategory = () => {
    //     this._includeCategories = [];
    //     let donor_view_category = this._donorLists[this._parentIndex].contents.donor_view_category;
    //     this._parentCategory = _.find(this.props.donors.donorCategories, { id: Number(donor_view_category) });
    //     for (var a = 0; a < this._donorLists[this._parentIndex].contents.include_categories.length; a++) {
    //         if (Number(this._donorLists[this._parentIndex].contents.include_categories[a]) !== Number(this._donorLists[this._parentIndex].contents.donor_view_category)) {
    //             this._includeCategories.push(this._donorLists[this._parentIndex].contents.include_categories[a])
    //         }
    //     }  
    // }

    informationalheader = (height, displayHeader) => {

        let aligner = {
            display: 'flex',
            alignItems: 'center',
            minHeight: height
        }

        let flexStyle = {
            paddingLeft: (this.props.screen.sv.width / 2) * 0.1,
            flex: 1,
            color: 'white',
            maxWidth: '50%',
            fontSize: this.props.screen.sv.height * .045
        }

        return (
            <div key={this.state.topBarHeader} className="legacyserif-mediumSC" style={{ position: 'absolute', width: this.props.screen.r16_9.width, height: height }}>
                <div style={aligner}>
                    {displayHeader ? <span style={flexStyle}>{this.state.topBarHeader}</span> : <span />}
                </div>
            </div>
        )
    }

    goIdle = (type) => {

    }

    cycleIdle = () => {

    }

    cycleIdleLoop = () => {

    }

    resume = () => {

    }

    cycleDonorIndex = (columns, rows) => {
        let total = columns * rows;
        let start = this._donorIndex * total;
        //let cat = this._donors[this._categoryCurrent];
        let cat = this._donorLists[this._parentIndex].donors[this._categoryCurrent]
        if (!cat.donors[start]) {
            start = 0
            this._donorIndex = 0;
        }

        let end_of_loop = false;
        let end = start + total;
        if (!cat.donors[end + 1]) {
            end = cat.donors.length;
            end_of_loop = true;
            this._donorIndex = 0;
        }
        else {
            this._donorIndex++
        }


        return {
            donors: cat.donors.slice(start, end),
            end_of_loop: end_of_loop,
            name: cat.name,
            subheader: cat.subheader,
            description: cat.description
        }

    }

    cycleEvent = () => {

        let eventInc = this.state.eventIndex;
        let renderSides, renderFull, renderWhite;
        eventInc++;

        if (eventInc > this._events.length - 1) {
            eventInc = 0;
        }
        switch (this._events[eventInc].name) {
            case "Donor List":
                //run a cycle
                this._parentIndex++;
                if (this._parentIndex >= this._donorLists.length) {
                    this._parentIndex = 0;
                }
                // this.initParentCategory();
                this.cycleDonorData(this._donorLists[this._parentIndex].contents.ni_options.columns, this._donorLists[this._parentIndex].contents.ni_options.rows);
                this.setState({
                    list: this._donorLists[this._parentIndex]
                })
                renderSides = true;
                renderFull = false;
                renderWhite = true;
                break;
            default:
                break;
            case "Slide":
                renderSides = false;
                renderFull = true;
                renderWhite = true;
                break;
            case "Background":
                renderSides = false;
                renderFull = false;
                renderWhite = false;
                break;
        }
        let showTopBar = true;

        if (this._events[eventInc].title === "") {
            showTopBar = false
        }
        this.setState({
            topBarHeader: this._events[eventInc].title,
            eventIndex: eventInc,
            renderSides: renderSides,
            renderFull: renderFull,
            renderWhite: renderWhite,
            showTopBar: showTopBar
        })
    }

    cycleIndex = () => {
        let index = this.state.cycleIndex;
        index++;
        if (index > 100) {//arbitrary to control total number
            index = 0
        }
        return index;
    }

    cycleDonorData = (columns, rows) => {
        //handle cycling donor content
        if (this._categoryCurrent < this._donorLists[this._parentIndex].donors.length) {
            let donorDataLeft, donorDataRight;

            donorDataLeft = this.cycleDonorIndex(columns, rows);

            if (donorDataLeft.end_of_loop === true) {
                this._categoryCurrent++;
            }
            if (this._categoryCurrent === 0 && this._donorIndex === 0) {
                donorDataRight = { donors: [], end_of_loop: true, name: "", description: "" }
            }
            else {
                if (this._categoryCurrent < this._donorLists[this._parentIndex].donors.length) {
                    donorDataRight = this.cycleDonorIndex(columns, rows);
                }
                else {
                    donorDataRight = { donors: [], end_of_loop: true, name: "", description: "" }
                }
                if (donorDataRight.end_of_loop === true) {
                    this._categoryCurrent++;
                }
            }
            this.setState({
                donorData: { left: { name: donorDataLeft.name, subheader: donorDataLeft.subheader, donors: donorDataLeft.donors, description: donorDataLeft.description }, right: { name: donorDataRight.name, subheader: donorDataRight.subheader, donors: donorDataRight.donors, description: donorDataRight.description } },
                cycleIndex: this.cycleIndex()
            })
        }
        else {
            this._categoryCurrent = 0;
            this._donorIndex = 0;
            this.cycleEvent();
        }
    }

    loopContent = () => {
        let event = this._events[this.state.eventIndex];

        switch (event.name) {
            case "Donor List":
            default:
                this.cycleDonorData(this._donorLists[this._parentIndex].contents.ni_options.columns, this._donorLists[this._parentIndex].contents.ni_options.rows);
                break;
            case "Slide":
                this.cycleEvent();
                break;
            case "Background":
                this.cycleEvent();
                break;
        }
        if (this._cycleImageNow === true) {
            this._cycleImageNow = false;
            this.setState({
                backgroundIndex: this._backgroundIndex
            })
        }
    }

    handleKeyDown = (e) => {
        switch (e.key) {
            case 'd':
                console.log(this.props);
                break;
            case '1':
                this.loopContent();
                break;
            case 'f':
                console.log(this._donors);
                break;
            case 'k':
                //this.clearCycleImageTimeout();
                //this.clearSetLoopTimeout();
                break;
            default:
                break;
        }
    }

    setFontAttributes = (styleObj, rootObj) => {
        //console.log('style', styleObj);
        //console.log('root', rootObj);
        styleObj.color = rootObj.fontColor;
        styleObj.fontWeight = rootObj.fontWeight;
        styleObj.textAlign = rootObj.justification.toLowerCase();
        styleObj.fontStyle = rootObj.fontStyle.toLowerCase();
        styleObj.fontFamily = rootObj.font;
        styleObj.fontSize = rootObj.fontSize * this.props.screen.screenHeight * .01;
        styleObj.lineHeight = String(rootObj.lineHeight)+'%';
        styleObj.width = '100%';
        styleObj.display = "inline-block";
    }

    setOffset = (setVar, styleObj) => {
        if (styleObj.visible === true) {
            setVar.val = this._sumH;// + (margin * .01 * this.props.screen.screenHeight);
            this._sumH += styleObj.height * .01 * this.props.screen.screenHeight;
        }
    }

    renderSide = (width, height, data, side, title) => {
        let parentDescription = ""
        if (side === "left" && this.state.list.category.description) {
            parentDescription = this.state.list.category.description
        }
        let subcategoryName = side === "left" ? this.state.donorData.left.name : this.state.donorData.right.name;
        let subcategorySubheader = side === "left" ? this.state.donorData.left.subheader : this.state.donorData.right.subheader;

        switch (data.type) {
            case "Donor List":
            default:
                if (this.state.renderSides === true) {
                    return (
                        <div style={{ width: width, height: height }} key={this.state.cycleIndex}>

                            {this.state.list.f.parentDescription.meta.visible ?
                                <div style={{ position: "absolute", left: width * .1, top: this.state.list.f.parentDescription.meta.offset, height: height, width: width * .8 }}>
                                    <span style={{ ...this.state.list.f.parentDescription.style }}><BRSpan preWrap str={parentDescription} /></span>
                                </div>
                                : null}

                            {this.state.list.f.subcategoryName.meta.visible ?
                                <div style={{ position: "absolute", left: width * .1, top: this.state.list.f.subcategoryName.meta.offset, height: height, width: width * .8 }}>
                                    <span style={{ ...this.state.list.f.subcategoryName.style }}><BRSpan preWrap str={subcategoryName} /></span>
                                </div>
                                : null}

                            {this.state.list.f.subcategorySubheader.meta.visible ?
                                <div style={{ position: "absolute", left: width * .1, top: this.state.list.f.subcategorySubheader.meta.offset, height: height, width: width * .8 }}>
                                    <span style={{ ...this.state.list.f.subcategorySubheader.style, letterSpacing: '0px' }}><BRSpan preWrap str={subcategorySubheader} /></span>
                                </div>
                                : null}

                            <div style={{ ...this.state.list.f.nameList.style, left: width * .1, position: "absolute", top: this.state.list.f.nameList.meta.offset, height: height * .6, width: width * .8 }}>
                                <DonorFullPage
                                    fontclass={this.state.list.f.nameList.style.fontFamily}
                                    height={this.state.list.f.nameList.meta.height*.01*this.props.screen.sv.height}
                                    width={width * .8}
                                    rows={this.state.list.contents.ni_options.rows}
                                    columns={this.state.list.contents.ni_options.columns}
                                    donorData={side === "left" ? this.state.donorData.left.donors : this.state.donorData.right.donors}
                                    screen={this.props.screen}
                                    sort="column"
                                    overrideFontSize={this.state.list.f.nameList.style.fontSize}
                                />
                            </div>

                        </div>
                    )
                }
                return (<span key={-1} />)
        }
    }

    renderFullPage = () => {
        if (this.state.renderFull === true) {
            if (this._events[this.state.eventIndex].name === "Slide") {
                // let top = 0;
                // let height = this.props.screen.sv.height;
                // if (this._fullScreenSlides===false){
                //     top = this.props.screen.sv.height * config.topBarHeight;
                //     height = height-(this.props.screen.sv.height * config.topBarHeight)
                // }
                return (
                    <div key={this.state.eventIndex} >
                        <StretchImage top={this._slideTop} left={0} height={this._slideHeight} width={this.props.screen.sv.width} src={this._events[this.state.eventIndex].image} />
                    </div>
                )
            }
            return (
                <span />
            )
        }
        return (
            <span />
        )
    }

    // renderWhitePanel = () => {
    //     if (this.state.renderWhite === true) {
    //         return (
    //             <div style={{ position: 'absolute', top: 0, left: 0, width: this.props.screen.sv.width, height: this.props.screen.sv.height - (config.topBarHeight * this.props.screen.sv.height), opacity: this._panelOpacity, backgroundColor: 'white' }} />
    //         )
    //     }
    //     else {
    //         return (
    //             <span />
    //         )
    //     }
    // }

    render() {
        if (!this.state.donorData.left || !this.state.list) {
            return (
                <span />
            )
        };
        let leftModule = this.renderSide(this.props.screen.sv.width / 2, this.props.screen.sv.height, { type: "Donor List" }, "left", this.state.list.category.name); //renderSide this._parentCategory.name
        let rightModule = this.renderSide(this.props.screen.sv.width / 2, this.props.screen.sv.height, { type: "Donor List" }, "right", this.state.list.category.name);

        let width = this.props.screen.sv.width / 2;
        let height = this.props.screen.sv.height;

        return (
            <div>


                {/* Background Image */}
                <div style={{ position: 'absolute', top: 0, left: 0, width: this.props.screen.sv.width, height: this.props.screen.sv.height }}>
                    <CSSTransitionGroup
                        component='div'
                        transitionName={this._fadeClass}
                        transitionEnterTimeout={0}
                        transitionLeaveTimeout={0}>
                        <div key={this.state.backgroundIndex} >
                            <StretchImage key={this.state.backgroundIndex} height={this.props.screen.sv.height} width={this.props.screen.sv.width} src={this._backgroundEvents[this.state.backgroundIndex].image} />
                        </div>
                    </CSSTransitionGroup>
                </div>

                {/* White */}
                <div style={{ position: 'absolute', top: this._slideTop, left: 0, width: this.props.screen.sv.width, height: this.props.screen.sv.height }}>
                    <CSSTransitionGroup
                        component='div'
                        transitionName='slowfade'
                        transitionEnterTimeout={0}
                        transitionLeaveTimeout={0}>
                        <div key={this.state.renderWhite}>
                            {this.state.renderWhite ? <div style={{ position: 'absolute', top: 0, left: 0, width: this.props.screen.sv.width, height: this._slideHeight, opacity: this._panelOpacity, backgroundColor: 'white' }} /> : <span />}
                        </div>
                    </CSSTransitionGroup>
                </div>


                {/* Full Page */}
                <div style={{ position: 'absolute', top: this.props.screen.sv.top, left: 0, height: this.props.screen.sv.height, width: this.props.screen.sv.width }}>
                    <CSSTransitionGroup
                        component='div'
                        transitionName={this._fadeClass}
                        transitionEnterTimeout={0}
                        transitionLeaveTimeout={0}>
                        {this.renderFullPage()}
                    </CSSTransitionGroup>
                </div>

                {/* Top Bar */}
                <CSSTransitionGroup
                    component='div'
                    transitionName='slowfade'
                    transitionEnterTimeout={0}
                    transitionLeaveTimeout={0}>
                    <div key={this.state.showTopBar}>
                        {this.state.showTopBar ? <div style={{ position: 'absolute', top: 0, left: 0, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height * config.topBarHeight, backgroundColor: '#424958' }} /> : <span />}
                    </div>
                </CSSTransitionGroup>

                {/* Left Split */}
                <div style={{ position: 'absolute', top: this.props.screen.sv.top, height: this.props.screen.sv.height, width: this.props.screen.sv.width / 2 }}>
                    <CSSTransitionGroup
                        component='div'
                        transitionName='slowfade'
                        transitionEnterTimeout={0}
                        transitionLeaveTimeout={0}>
                        {this.informationalheader(this.props.screen.sv.height * config.topBarHeight, true)}

                        <div key={this.state.list.category.name + this.state.eventIndex}>
                            {this.state.list.f.parentName.meta.visible && this._events[this.state.eventIndex].name === "Donor List" ?
                                <div style={{ position: "absolute", left: width * .1, top: this.state.list.f.parentName.meta.offset, height: height, width: width * .8 }}>
                                    <span style={{ letterSpacing: 2, width: '100%', display: 'inline-block' }}><span style={{ ...this.state.list.f.parentName.style }}><BRSpan preWrap str={this.state.list.category.name} /></span></span>
                                </div>
                                : null}
                        </div>

                        {leftModule}

                    </CSSTransitionGroup>
                </div>

                {/* Right Split */}
                <div style={{ position: 'absolute', top: this.props.screen.sv.top, left: this.props.screen.sv.width / 2, height: this.props.screen.sv.height, width: this.props.screen.sv.width / 2 }}>
                    <CSSTransitionGroup
                        component='div'
                        transitionName='slowfade'
                        transitionEnterTimeout={0}
                        transitionLeaveTimeout={0}>
                        {this.informationalheader(this.props.screen.sv.height * config.topBarHeight, false)}
                        {rightModule}
                        <div key={this._events[this.state.eventIndex].name}>
                        {this.state.list.f.footer.meta.visible && this._events[this.state.eventIndex].name==="Donor List" ?
                            <div style={{ position: "absolute", top: this.state.list.f.footer.meta.offset, height: height * .1, marginLeft: width * .1, marginRight: width * .1, width: (this.props.screen.sv.width / 2)*.8 }}>
                                <span style={{ ...this.state.list.f.footer.style }}><BRSpan preWrap str={this.state.list.contents.ni_options.footerText} /></span>
                            </div>
                            : null}
                        </div>
                    </CSSTransitionGroup>
                </div>

            </div>

        );
    }



}

const mapStateToProps = (state) => {
    return {
        content: state.content,
        donors: state.donors,
        screen: state.screen
    };
};

const mapDispatchToProps = (dispatch) => {
    return {

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DisplayContainer);


// WEBPACK FOOTER //
// ./src/containers/dc2x1.js